import { useTranslation } from "react-i18next";
import {useState, useEffect, useRef, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import {treeActions} from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import OverrideRootElement from "../OverrideRootElement";
import { FormControl, InputLabel, MenuItem, Select, Stack, TextField, Button } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import OverrideInboundDelimeter from "../OverrideInboundDelimeter";
import WorkflowSessionModal from "../../ItemProperties/WorkflowSessionModal";
import { validateRevertTime } from "../../../utils/validate";

export default function JSONForm() {
  const { t } = useTranslation();
  const fileBrowser = useRef();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [validationType, setValidationType] = useState('NONE');
  const [schemaLocation, setSchemaLocation] = useState('');
  const [modalOpen, setModalOpen] = useState({ open: false, isFirstTime: false});
  const [schemaError, setSchemaError] = useState('');

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setValidationType(header.VALIDATION_TYPE || 'NONE');
    setSchemaLocation(header.FILE_PATH || '');
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }

  const connectionClickHandler = () => {
      alert('--MODAL COMING SOON--')
  }

  const handleSchema = (e) =>{
    const newValue = e.target.value;
    const oldValue = rightTree?.tree?.templateHeader?.["FILE_PATH"]
    if(oldValue && !newValue) {
      setSchemaError(t('BOX_LOC_MUST_BE_SPECIFIED'));
      setTimeout(()=>setSchemaError(''),3000);
      setSchemaLocation(oldValue);
      return;
    }
    handleChange('FILE_PATH', newValue);
  }

  const setFinalValue = (value) => {
    setSchemaLocation(value);
    handleChange('FILE_PATH', value);
  } 

  return (
    <>
      <>
        <FormControl size="small" variant="outlined">
          <InputLabel id="validationDropdownLabel">{t('LBL_VALID_TYPE')}</InputLabel>
          <Select
            className="width-100"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 250
                }
              }
            }}
            labelId="validationDropdownLabel"
            id="validationDropdown"
            value={validationType}
            onChange={(e) => {
              setValidationType(e.target.value);
              handleChange('VALIDATION_TYPE', e.target.value)
            }}
            label={t('LBL_VALID_TYPE')}
          >
            {[
              <MenuItem key={'NONE'} value='NONE'>{t('NONE')}</MenuItem>,
              <MenuItem key={'SCHEMA'} value='SCHEMA'>{t('SCHEMA')}</MenuItem>
            ]}
          </Select>
        </FormControl>
        {
          validationType === 'SCHEMA' ? (
            <div className="flex">
              <TextField 
                autoComplete="false"
                className="width-100"
                label={t('LBL_SCHEMA_LOC')} 
                variant="outlined" 
                size="small"
                placeholder=''
                value={schemaLocation}
                onChange={(e) => {
                  setSchemaLocation(e.target.value);
                }}
                onBlur={handleSchema}
                error={schemaError ? true : false}
                helperText={schemaError}
              />
               <input 
                  style={{'display': 'none'}} 
                  type="file" 
                  ref={fileBrowser} 
                  onChange={(e) => {
                    setSchemaLocation(e.target.value);
                    handleChange('FILE_PATH', e.target.value)
                  }} 
                />
              <Button
                variant="outlined"
                size="small"
                disableElevation
                className='margin-left-4'
                sx={{
                  width: '40px', 
                  padding: '4px 8px',
                  minWidth: '40px',
                }}
                onClick={() => {
                  setModalOpen({open: true, isFirstTime: true});
                }}
              >
                <MoreHorizIcon fontSize="small" />
              </Button>
            </div>
          ) : ''
        }
        {parentScreen === 'inbound' && <OverrideRootElement /> }
      </>

      {parentScreen === 'inbound' && <GroupByName /> }
      {parentScreen === 'outbound' && <OverrideInboundDelimeter/>}
      <WorkflowSessionModal
        valueLabel={t("TXT_LOCATE_SCHEMA")}
        showAccountData={true}
        showCallingWorkflow={true} 
        showSystemData={true}
        showDateAndTime={true}
        setModalOpen={setModalOpen} 
        openModal={modalOpen} 
        handleClose={()=>setModalOpen({open: false, isFirstTime: false})} 
        initialValue={schemaLocation}
        valuesHandler={setFinalValue}
      />
    </>
  )
}
